import SummaryPage from './SummaryPage';
import ChangePlanPage from './ChangePlanPage.container';
import EnableAutomaticBillingPage from './EnableAutomaticBillingPage';

export default {
  SummaryPage,
  ChangePlanPage,
  EnableAutomaticBillingPage
};
